<template>
  <div>
    <slot></slot>
    <div v-if="showLoading" class="pullup-wrapper">
      <div class="after-trigger">
        <v-loading-more :isLoading="hasNext" :noMoreText="showMoreText ? '已经到底了~' : ''" />
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'utils/common'

export default {
  name: 'native-scroll',
  data() {
    return {}
  },
  props: {
    selector: {
      type: String,
      default: '.v-page'
    },
    showLoading: {
      type: Boolean,
      default: false
    },
    hasNext: {
      type: Boolean,
      default: true
    },
    showMoreText: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollEvent)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  methods: {
    scrollEvent() {
      return debounce(this.scroll, 300)()
    },
    scroll() {
      if (this.isReachBottom()) {
        this.$emit('scrolling')
      }
    },
    isReachBottom() {
      const scrollT = document.documentElement.scrollTop || document.body.scrollTop
      const containerH = document.documentElement.offsetHeight
      const eleH = document.querySelector(this.selector).offsetHeight
      return scrollT + containerH + 100 > eleH
    }
  }
}
</script>

<style scoped lang="scss">
.pullup-wrapper {
  font-size: 33px;
  background-color: #fafafa;
  text-align: center;
  display: block;
  pointer-events: none;
  .done-text {
    padding: 36px 0;
    @include os-font-weight(33, 40);
    color: #a9a9a9;
  }
}
</style>
